var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUndo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2071 13.2816C12.1358 13.2816 10.2599 14.0554 8.81387 15.3139L6 12.5V19.5347H13.0347L10.2052 16.7052C11.2916 15.7985 12.6751 15.2357 14.2071 15.2357C16.9741 15.2357 19.3268 17.0413 20.1475 19.5347L22 18.925C20.9135 15.65 17.8417 13.2816 14.2071 13.2816Z",
    fill: "#6C737F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndo);
export default __webpack_public_path__ + "static/media/undo.f59f48748cbca3d055d3081127f79f9f.svg";
export { ForwardRef as ReactComponent };